import type { AxiosDefaults, AxiosRequestConfig, AxiosResponse } from 'axios';
import type { HttpClientInterface } from './http-client.interface.ts';
import type { Config } from './http-client.types.ts';
import { setupInterceptors } from './interceptors/setup.interceptors.ts';
import { createAxiosInstance } from './utils/create-axios-instance.ts';
import { normalizeError } from './utils/errors.functions.ts';

export class HttpClient implements HttpClientInterface<AxiosRequestConfig, AxiosResponse> {
  private readonly axiosInstance;

  constructor(baseURL?: string, customConfig?: AxiosRequestConfig) {
    this.axiosInstance = createAxiosInstance(baseURL, customConfig);
    setupInterceptors(this.axiosInstance);
  }

  get config(): AxiosDefaults {
    return this.axiosInstance.defaults;
  }

  set config(newConfig: Partial<AxiosDefaults>) {
    Object.assign(this.axiosInstance.defaults, newConfig);
  }

  async request<TOutput>(config: Config): Promise<AxiosResponse<TOutput>> {
    try {
      const response = await this.axiosInstance.request<TOutput>(config);
      return response;
    } catch (error) {
      throw normalizeError(error);
    }
  }
}
